<template>
  <div id="registerBlock" class="container content clearfix">
    <div class="wrapper clearfix">
      <div style="padding: 5px">
        <br />
        <p>
          <strong
            >{{
              $t("Thank you for registering for" + this.prov_short, {
                election_name: election_name,
              })
            }}.</strong
          >
        </p>
        <p>
          {{
            $t(
              "You have been sent a confirmation email containing all of your registration information. Please review it and inform us of any changes as early as possible."
            )
          }}
        </p>
        <p>
          {{
            $t(
              "If the message has not arrived in your mailbox, please check your junk folder or check with our team to make sure that your registration was submitted."
            )
          }}
        </p>
        <p
          v-html="
            $t(
              'If you need any assistance, please don\'t hesitate to contact us at 1-866-488-8775 or hello@civix.ca'
            )
          "
        ></p>
        <!--<p>
          <a :href="'http://twitter.com/intent/tweet?text=' + english_tweet">{{
            $t("Tweet your registration")
          }}</a>
        </p>-->
        <p>
          <a :href="$t('site')">{{ $t("Return to Student Vote") }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  data: function () {
    return {
      election_name: "",
      english_tweet: "",
      prov_short: 'NS',
    };
  },
  props: {
    election_id: String,
  },
  mounted: function () {
    this.getElection(this.election_id);
  },
  methods: {
    getElection(election_id) {
      let url =
        this.$API + "/get_election/" + election_id + "/" + this.$i18n.locale;
      fetch(url, {
        method: "GET",
        //headers: new Headers({
        //  'x-api-key': this.$TOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          if (response.error) {
            //console.log("error");
          } else {
            //console.log(response);
            this.election_name = response.election_name;
            this.english_tweet = response.english_tweet;
            this.prov_short = response.province;
          }
        })
        .catch((_error) => {
          this.isLoading = false;
          //console.log('ERROR getTableData: '+error)
        });
    },
  },
};
</script>